var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.00632 13.5L9.49368 13.5C9.69717 13.5019 9.88464 13.4216 10.022 13.2885C10.0938 13.219 10.152 13.135 10.1916 13.0408C10.2234 12.9652 10.2432 12.8832 10.2485 12.7974L10.9471 3.25003H11.25C11.6642 3.25003 12 2.91424 12 2.50003C12 2.08581 11.6642 1.75003 11.25 1.75003H10.2563H10.2421H7.95732C7.98496 1.67183 8 1.58769 8 1.50003C8 1.08581 7.66421 0.750028 7.25 0.750028H5.25C4.83579 0.750028 4.5 1.08581 4.5 1.50003C4.5 1.58769 4.51504 1.67183 4.54268 1.75003H2.25788C2.25316 1.74998 2.24843 1.74998 2.24369 1.75003H1.25C0.835787 1.75003 0.5 2.08581 0.5 2.50003C0.5 2.91424 0.835787 3.25003 1.25 3.25003H1.55287L2.25163 12.7996C2.26486 13.0022 2.35854 13.1829 2.50104 13.31C2.57815 13.3787 2.66956 13.4318 2.77025 13.4642C2.84485 13.4882 2.92428 13.5008 3.00632 13.5ZM3.69713 12L8.80287 12L9.44312 3.25003L3.05688 3.25003L3.69713 12Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.d6407647e57498fc7693949a0d89e003.svg";
export { ForwardRef as ReactComponent };